import React from "react";
import { Navigate } from "react-router-dom";

interface OnboardingGuardProps {
  children: React.ReactNode;
}

const OnboardingGuard: React.FC<OnboardingGuardProps> = ({ children }) => {
  const isOnboardingDisabled = import.meta.env.VITE_DISABLED_ONBOARDING === "true";

  if (isOnboardingDisabled) {
    return <Navigate to="/funnels" replace />;
  }

  return <>{children}</>;
};

export default OnboardingGuard;
